<template>
	<div id="app" class="shadow">
		<Viewpage />
		<div class="dropdown-inners">
			<div ref="dropdownOverlays"></div>
			<div ref="dropdownMenus"></div>
		</div>
	</div>
</template>

<script>
import Viewpage from './components/Viewpage.vue';
import { mapActions } from 'vuex';

export default {
	name: 'app',
	components: {
		Viewpage
	},
	mounted() {
		this.$root.$app = this;

		for (
			let providerI = 0;
			providerI < this.$store.state.loadDefaultProviders.length;
			providerI++
		) {
			let providerName = this.$store.state.loadDefaultProviders[
				providerI
			];

			console.debug('loading provider', providerName);
			const provider = require('./store/modules/ConversationProviders/' +
				providerName).default;

			this.$store.registerModule(
				['ConversationProviders', 'provider_' + providerName],
				provider
			);
			this.$store.dispatch(
				'ConversationProviders/addConversationProvider',
				providerName
			);
		}

		// this.openConversation(['local', 'b07c302a-836e-49c0-9d31-6485a776913d']);

		for (
			let pluginI = 0;
			pluginI < this.$store.state.loadDefaultPlugins.length;
			pluginI++
		) {
			let pluginName = this.$store.state.loadDefaultPlugins[pluginI];

			this.installPlugin(pluginName);
		}
	},
	methods: {
		...mapActions(['openConversation'])
	}
};
</script>

<style lang="scss">
@import '../node_modules/normalize.css/normalize.css';
@import 'scss/main.scss';
</style>
